<!-- src/views/HomePage.vue -->
<template>
  <v-container class="home-page" max-width=1200>
    <MolecularBackground />
    <!-- 公告栏 -->
    <section class="announcement-section">
        <div class="announcements-container">
            <div class="announcement-scroll">
                <div class="announcement-list"  v-if="announcements.length > 0">
                            <!-- $type = get_post_meta($announcement->ID, '_announcement_type', true); -->
                    <div :class="['announcement-item', announcement.class_list.join(' ')]" 
                    v-for="announcement in announcements" 
                    :key="announcement.id" 
                    :data-title="announcement.title.rendered" 
                    :data-date="announcement.date" 
                    :data-content="announcement.content.rendered" 
                    @click="openModal(announcement.title.rendered, announcement.date, announcement.content.rendered)">
                        {{ announcement.title.rendered }}
                        {{ announcement.date }}
                    </div>
                </div>
                <div class="no-announcements" v-else>
                    {{ $t('homePage.noAnnouncements') }}
                </div>
            </div>
        </div>
    </section>

    <!-- 公告弹窗 -->
    <div class="announcement-modal" v-show="isModalActive">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">{{ modalTitle }}</h3>
                <div class="modal-date">{{ modalDate }}</div>
                <button class="modal-close" @click="closeModal">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                </button>
            </div>
            <div class="modal-body">
                <div class="modal-content-wrapper" v-html="modalContent"></div>
            </div>
        </div>
    </div>
    <!-- 主标题区域 -->
    <section class="intro-section">
      <div class="intro-content">
        <h1>
          <img :src="require('@/assets/images/logo_vector.svg')" alt="Goplus" />
        </h1>
        <h2>{{ $t('homePage.slogan') }}</h2>
        <p v-html="introText"></p>
      </div>
      <!-- <div class="intro-image" v-if="!isMobile">
        <model-viewer
          v-if="modelData"
          :src="modelData.model.modelUrl"
          alt="A 3D model"
          auto-rotate
          camera-controls
          :style="{ width: modelData.styles.width.desktop, height: modelData.styles.height.desktop, backgroundColor: modelData.styles.bgColor }"
          :environment-image="modelData.environmentImage"
          reveal="auto"
          shadow-intensity="1"
          exposure="1"
          :draco-decoder-path="useDracoDecoder ? modelData.model.binFile : undefined"
        ></model-viewer>
      </div> -->
    </section>

    <!-- 首发区域 -->
    <section class="launch-section">
      <div class="launch-container">
        <div class="launch-title">{{ $t('homePage.launchTitle') }}</div>
        <div class="counter-box">
          <div class="counter-content">
            <div class="counter-wrapper">
              <div class="counter">{{ counter }}</div>
            </div>
            <div class="system-time">{{ $t('homePage.systemTime') }}</div>
          </div>
        </div>
        <a :href="featuredProductLink" class="cta-button">{{ $t('homePage.buyNow') }}</a>
      </div>
    </section>

<!-- CoreTrust优点 -->
<section class="features-section">
    <h2 class="section-title">{{ $t('homePage.featuresTitle') }}</h2>

    <!-- 展示熄屏广告 -->
    <div class="feature-item">
        <div class="feature-content">
            <h3>{{ $t('homePage.features.screenOffAd.title') }}</h3>
            <p>{{ $t('homePage.features.screenOffAd.description1') }}</p>
            <p>{{ $t('homePage.features.screenOffAd.description2') }}</p>
            <p>{{ $t('homePage.features.screenOffAd.description3') }}</p>
            <p>{{ $t('homePage.features.screenOffAd.description4') }}</p>
        </div>
        <div class="feature-image">
            <img :src="require('@/assets/images/features/screen-ad.png')" :alt="$t('homePage.features.screenOffAd.title')">
        </div>
    </div>

    <!-- 分散式多链电话 -->
    <div class="feature-item">
        <div class="feature-content">
            <h3>{{ $t('homePage.features.decentralizedPhone.title') }}</h3>
            <p>{{ $t('homePage.features.decentralizedPhone.description1') }}</p>
            <p>{{ $t('homePage.features.decentralizedPhone.description2') }}</p>
        </div>
        <div class="feature-image phones-display">
            <img :src="require('@/assets/images/features/multi-chain-phones.png')" :alt="$t('homePage.features.decentralizedPhone.title')">
        </div>
    </div>

    <!-- 硬件钱包账户 -->
    <div class="feature-item">
        <div class="feature-content">
            <h3>{{ $t('homePage.features.hardwareWallet.title') }}</h3>
            <p>{{ $t('homePage.features.hardwareWallet.description1') }}</p>
            <p>{{ $t('homePage.features.hardwareWallet.description2') }}</p>
        </div>
        <div class="feature-image">
            <img :src="require('@/assets/images/features/wallet-account.png')" :alt="$t('homePage.features.hardwareWallet.title')">
        </div>
    </div>

    <!-- 空投功能 -->
    <div class="feature-item">
        <div class="feature-content">
            <h3>{{ $t('homePage.features.airdropFunctionality.title') }}</h3>
            <p>{{ $t('homePage.features.airdropFunctionality.description1') }}</p>
            <p>{{ $t('homePage.features.airdropFunctionality.description2') }}</p>
            <p>{{ $t('homePage.features.airdropFunctionality.description3') }}</p>
        </div>
        <div class="feature-image">
            <img :src="require('@/assets/images/features/airdrop.png')" :alt="$t('homePage.features.airdropFunctionality.title')">
        </div>
    </div>

    <!-- 安全隔离 -->
    <div class="feature-item">
        <div class="feature-content">
            <h3>{{ $t('homePage.features.securityIsolation.title') }}</h3>
            <p>{{ $t('homePage.features.securityIsolation.description1') }}</p>
            <p>{{ $t('homePage.features.securityIsolation.description2') }}</p>
            <p>{{ $t('homePage.features.securityIsolation.description3') }}</p>
        </div>
        <div class="feature-image">
            <img :src="require('@/assets/images/features/security.png')" :alt="$t('homePage.features.securityIsolation.title')">
        </div>
    </div>
</section>

<!-- 介绍文字区域 -->
<div class="roadmap-description">
    <p>{{ $t('homePage.roadmapDescription') }}</p>
    <p>{{ $t('homePage.roadmapDescription1') }}</p>
</div>

<!-- 发展路线图 -->
    <v-timeline align="start" side="end" class="d-md-none">
        <v-timeline-item dot-color="pink"
        size="small">
        <v-list> 
            <v-list-item>
                <v-list-item-title class="time">{{ $t('homePage.roadmap.2025.time') }}</v-list-item-title>
                <v-list-item>
                    <v-list-item-title>{{ $t('homePage.roadmap.2025.description') }}</v-list-item-title>
                    <v-list-item-subtitle>
                        <div class="description">{{$t('homePage.roadmap.2025.targetUsers')}}</div>
                        <div class="milestone">{{$t('homePage.roadmap.2025.milestone')}}</div>
                    </v-list-item-subtitle>
                </v-list-item>
            </v-list-item>
        </v-list>
        </v-timeline-item>
        <v-timeline-item  dot-color="teal-lighten-3"
        size="small">
        <v-list>
            <v-list-item>
                <v-list-item-title class="time">{{ $t('homePage.roadmap.2026.time') }}</v-list-item-title>
                <v-list-item>
                    <v-list-item-title>{{ $t('homePage.roadmap.2026.description') }}</v-list-item-title>
                    <v-list-item-subtitle>
                        <div class="description">{{$t('homePage.roadmap.2026.userScale')}}</div>
                        <div class="milestone">{{$t('homePage.roadmap.2026.milestone')}}</div>
                    </v-list-item-subtitle>
                </v-list-item>
            </v-list-item>
        </v-list>
        </v-timeline-item>
        <v-timeline-item dot-color="primary"
        size="small">
            <v-list>
                <v-list-item>
                    <v-list-item-title class="time">{{ $t('homePage.roadmap.2027.time') }}</v-list-item-title>
                    <v-list-item>
                        <v-list-item-title>{{ $t('homePage.roadmap.2027.description') }}</v-list-item-title>
                        <v-list-item-subtitle>
                            <div class="description">{{$t('homePage.roadmap.2027.userScale')}}</div>
                            <div class="milestaone">{{$t('homePage.roadmap.2027.milestone')}}</div>
                        </v-list-item-subtitle>
                    </v-list-item>
                </v-list-item>
            </v-list>
        </v-timeline-item>
        <v-timeline-item dot-color="teal-lighten-3"
        size="small">
        <v-list>
            <v-list-item>
                <v-list-item-title class="time">{{ $t('homePage.roadmap.2028.time') }}</v-list-item-title>
                <v-list-item>
                    <v-list-item-title>{{ $t('homePage.roadmap.2028.description') }}</v-list-item-title>
                    <v-list-item-subtitle>
                        <div class="description">{{$t('homePage.roadmap.2028.userScale')}}</div>
                        <div class="milestone">{{$t('homePage.roadmap.2028.milestone')}}</div>
                    </v-list-item-subtitle>
                </v-list-item>
            </v-list-item>
        </v-list>
        </v-timeline-item>
    </v-timeline>
<section class="roadmap-section">
    <div class="world-map-bg"></div>
    <div class="roadmap-container">
        <h2 class="section-title">{{ $t('homePage.roadmapTitle') }}</h2>
        <div class="roadmap-grid">
            <div class="roadmap-item">
                <div class="time">{{ $t('homePage.roadmap.2025.time') }}</div>
                <div class="milestone-content">
                    <div class="stage-desc">{{ $t('homePage.roadmap.2025.description') }}</div>
                    <div class="milestone-row">
                        <span class="description">{{ $t('homePage.roadmap.2025.targetUsers') }}</span>
                        <span class="milestone">{{ $t('homePage.roadmap.2025.milestone') }}</span>
                    </div>
                </div>
            </div>
            <div class="roadmap-item">
                <div class="time">{{ $t('homePage.roadmap.2026.time') }}</div>
                <div class="milestone-content">
                    <div class="stage-desc">{{ $t('homePage.roadmap.2026.description') }}</div>
                    <div class="milestone-row">
                        <span class="description">{{ $t('homePage.roadmap.2026.userScale') }}</span>
                        <span class="milestone">{{ $t('homePage.roadmap.2026.milestone') }}</span>
                        <span class="description">{{ $t('homePage.roadmap.2026.secondRound') }}</span>
                    </div>
                </div>
            </div>
            <div class="roadmap-item">
                <div class="time">{{ $t('homePage.roadmap.2027.time') }}</div>
                <div class="milestone-content">
                    <div class="stage-desc">{{ $t('homePage.roadmap.2027.description') }}</div>
                    <div class="milestone-row">
                        <span class="description">{{ $t('homePage.roadmap.2027.userScale') }}</span>
                        <span class="milestone">{{ $t('homePage.roadmap.2027.milestone') }}</span>
                    </div>
                </div>
            </div>
            <div class="roadmap-item">
                <div class="time">{{ $t('homePage.roadmap.2028.time') }}</div>
                <div class="milestone-content">
                    <div class="stage-desc">{{ $t('homePage.roadmap.2028.description') }}</div>
                    <div class="milestone-row">
                        <span class="description">{{ $t('homePage.roadmap.2028.userScale') }}</span>
                        <span class="milestone">{{ $t('homePage.roadmap.2028.milestone') }}</span>
                        <span class="description">{{ $t('homePage.roadmap.2028.ecosystem') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

    <!-- 合作伙伴区域 -->
    <section class="partners-section">
      <h2 class="partners-title">{{ $t('homePage.partnersTitle') }}</h2>
      <div class="partners-container">
        <div class="partners-scroll">
          <PartnerItem v-for="partner in partners" :key="partner.id" :partner="partner" @click="handlePartnerClick" />
        </div>
      </div>
    </section>
</v-container>
</template>

<script>
import PartnerItem from '@/components/PartnerItem.vue';
import { fetchAnnouncements, fetchIntroText, fetchPartners } from '@/api/apiService';
import MolecularBackground from '@/components/MolecularBackground.vue';
import '@google/model-viewer';

export default {
  name: 'HomePage',
  components: {
    PartnerItem,
    MolecularBackground,
  },
  data() {
    return {
      announcements: [],
      introText: '',
      modelData: null,
      counter: 10000,
      featuredProductLink: '/product/featured', // 假设有一个产品页面
      partners: [],
      features: [
        {
          id: 1,
          title: '多链支持',
          description: '支持多种区块链网络，提供无缝的跨链体验。',
          image: require('@/assets/images/features/multi-chain-phones.png'),
        },
        {
          id: 2,
          title: '安全保障',
          description: '采用先进的安全技术，确保用户资产安全。',
          image: require('@/assets/images/features/security.png'),
        },
        {
          id: 3,
          title: '钱包账户',
          description: '集成多种钱包，方便管理和使用数字资产。',
          image: require('@/assets/images/features/wallet-account.png'),
        },
        {
          id: 4,
          title: '空投奖励',
          description: '参与空投活动，获取更多奖励。',
          image: require('@/assets/images/features/airdrop.png'),
        },
        {
          id: 5,
          title: '屏幕广告',
          description: '通过屏幕广告获取收益，提升用户体验。',
          image: require('@/assets/images/features/screen-ad.png'),
        },
      ],
      isModalActive: false,
      modalTitle: '',
      modalDate: '',
      modalContent: '',
    };
  },
  computed: {
    useDracoDecoder() {
      return this.modelData && this.modelData.model.decoder === 'Draco';
    },
    isMobile() {
      return window.innerWidth < 768;
    }
  },
  mounted() {
    this.fetchData();
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  watch: {
    '$i18n.locale': {
      handler: 'fetchData',
      immediate: true,
    },
  },
  methods: {
    handlePartnerClick(url) {
      window.open(url, '_blank');
    },
    fetchData() {
      // 使用 apiService 获取公告
      fetchAnnouncements().then(response => {
        this.announcements = response;
      }).catch(error => {
        console.error('Error fetching announcements:', error);
      });

      // 使用 apiService 获取介绍文本
      fetchIntroText().then(response => {
        if (response.data.length > 0) {
          this.introText = response.data[0].content.rendered;
        }
      });

      // 使用 apiService 获取 3D 模型 URL
    //   fetchModelUrl().then(response => {
    //     this.modelData = response;
    //   });

      // 使用 apiService 获取合作伙伴
      fetchPartners().then(response => {
        this.partners = response;
      }).catch(error => {
        console.error('Error fetching partners:', error);
      });

      // 根据需要获取他数据
    },
    openModal(title, date, content) {
      this.modalTitle = title;
      this.modalDate = date;
      this.modalContent = this.decodeHTMLEntities(content);
      
      this.isModalActive = true;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.isModalActive = false;
      document.body.style.overflow = '';
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.isModalActive) {
        this.closeModal();
      }
    },
    decodeHTMLEntities(text) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    },
  },
};
</script>

<style scoped>

/* 主标题区域 */
.hero-section {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
    text-align: left;
}

.main-title {
    font-size: 36px;
    line-height: 1.4;
    color: var(--primary-color);
    margin-bottom: 20px;
}

.subtitle {
    font-size: 16px;
    line-height: 1.6;
    color: #666;
    max-width: 600px;
}

/* 首发区域 */
.launch-section {
    position: relative;
    padding: 60px 80px;
    text-align: center;
}

.launch-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 15px 0px;
    background: linear-gradient(180deg, 
        rgba(237, 255, 243, 0.2) 0%,
        rgba(230, 255, 238, 0.25) 50%,
        rgba(221, 255, 231, 0.3) 100%
    );
    backdrop-filter: blur(2px);
    /* background: radial-gradient(50% 50% at 50% 50%, rgba(165, 214, 167, 0.3) 0%, rgba(5, 83, 33, 0.1) 100%); */
    border-radius: 5px;
}

.launch-title {
    font-family: 'Noto Sans', sans-serif;
    font-size: 38px;
    font-weight: 700;
    line-height: 52px;
    letter-spacing: 0.42em;
    text-align: left;
    margin-bottom: 5px;
    background: radial-gradient(50% 50% at 50% 50%, #A5D6A7 0%, #055321 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-decoration: none;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    position: relative;
    display: inline-block;
}

.launch-title::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.2);
    filter: blur(4px);
    transform: translate(-50%, -50%);
    z-index: -1;
    opacity: 0.5;
}

@keyframes glow {
    from {
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
    }
    to {
        text-shadow: 0 0 20px rgba(255, 255, 255, 1);
    }
}

/* 计数器容器和内���样式 */
.counter-box {
    position: relative;
    background: url('@/assets/images/launch/counter-bg.png') center/cover no-repeat;
    border-radius: 20px;
    padding: 25px;
    max-width: 400px;
    margin: 5px auto;
    overflow: hidden;
}

.counter-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 25px;
}

/* 数字容器和文字样式 */
.counter-wrapper {
    background: linear-gradient(90deg, #A5D6A7 0%, #44ADFF 100%);
    border-color: #006838;
    opacity: 0.6;
    border-radius: 12px;
    padding: 5px 10px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.counter {
    font-family: 'Noto Sans', sans-serif;
    font-size: 48px;
    font-weight: 700;
    color: #0C0B28;
    text-align: center;
    letter-spacing: 2px;
}

.system-time {
    font-family: 'Noto Sans', sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    text-align: center;
    background: #000;
    padding: 8px 10px;
    border-radius: 5px;
    color: #fff;
}

/* 购买按钮 */
.cta-button {
    display: inline-block;
    padding: 6px 20px;
    background: #67ab5a;
    color: var(--white);
    border-radius: 30px;
    text-decoration: none;
    font-weight: 500;
    margin-top: 10px;
    transition: transform 0.3s ease;
}

.cta-button:hover {
    transform: translateY(-2px);
}

/* 优点区域 */
.features-section {
    max-width: 1200px;
    margin: 4rem auto;
    padding: 60px 80px;
}

/* 每个优点项目 */
.feature-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 100px;
    gap: 40px;
    width: 100%;
}

.section-title {
    font-size: 32px;
    color: #055321;
    margin-bottom: 40px;
}

/* 设置奇偶项的方向和文字对齐 */
.feature-item:nth-child(odd) {
    flex-direction: row-reverse;
}

.feature-item:nth-child(odd) .feature-content {
    text-align: right;
}

.feature-item:nth-child(even) {
    flex-direction: row;
}

.feature-item:nth-child(even) .feature-content {
    text-align: left;
}

/* 调整内容区域占比为70% */
.feature-content {
    width: 70%;
    flex: 0 0 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.feature-content h3 {
    font-size: 24px;
    color: var(--primary-color);
    margin-bottom: 20px;
}

.feature-content p {
    font-size: 14px;
    line-height: 1.6;
    color: #055321;
}

/* 调整图片区域占为30% */
.feature-image {
    width: 30%;
    flex: 0 0 30%;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 统一图片样式 */
.feature-image img {
    height: 400px;
    width: auto;
    object-fit: contain;
    max-width: 100%;
}

/* 介绍文字区域 */
.roadmap-description {
    max-width: 1200px;
    margin: 80px auto;
    text-align: center;
}

.roadmap-description p {
    font-size: 20px;
    line-height: 1.5;
    margin: 5px 0;
    background: linear-gradient(271.79deg, #055321 10.48%, #77A792 99.49%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* 路线图背景 */
.world-map-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-image: url('@/assets/images/world-map.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0.7;  /* 调整透度使背景更淡 */
    z-index: 0;
}

/* 路线图区域 */
.roadmap-section {
    width: 100%;
    position: relative;
    padding: 60px 0;
}
.roadmap-container {
    max-width: 1200px;
    margin: 0 auto;
}

/* 路线图容器 */
.roadmap-grid {
    position: relative;
    display: flex;
    justify-content: flex-start;
    margin-top: 40px;
    padding-left: 120px;
    width: calc(100% - 120px);
    gap: 50px;
}

/* 时间节点容器 */
.roadmap-item {
    position: relative;
    width: auto;
    min-width: 230px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 10px;
}

/* 横线基础样式 */
.roadmap-item::after {
    content: '';
    position: absolute;
    top: 15px;
    height: 2px;
    background: #055321;
    width: calc(100% + 50px);
    left: 12px;
}

/* 圆点样式 */
.roadmap-item::before {
    content: '';
    position: absolute;
    top: 11px;
    left: 0;
    width: 12px;
    height: 12px;
    background: #055321;
    border: 2px solid #fff;
    border-radius: 50%;
    z-index: 2;
    transform: none;
    box-shadow: 0 0 0 4px #fff;
}

/* 时间文字调整 */
.time {
    position: absolute;
    top: 35px;
    left: 0;
    transform: none;
    font-size: 14px;
    color: #055321;
    white-space: nowrap;
    font-weight: bold;
}

/* milestone内容调整 */
.milestone-content {
    margin-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}

/* 数字和用规模行 */
.milestone-row {
    display: flex;
    align-items: baseline;
    gap: 4px;
    white-space: nowrap;
    position: relative;
    left: -10px;
}

/* 数字样式 */
.milestone {
    font-size: 18px;
    line-height: 1.1;
    color: #055321;
    font-weight: 500;
}

/* 说明文字样式 */
.stage-desc {
    font-size: 11px;
    line-height: 1.4;
    color: #055321;
    text-align: left;
    white-space: nowrap;
    margin-top: 0;
    min-width: 180px;
    letter-spacing: -0.2px;
    position: relative;
    left: -10px;
}

/* 第一个节点特殊处理 */
.roadmap-item:first-child .milestone-content {
    left: 0;
    transform: none;
    margin-left: -30px;
}

.roadmap-item:first-child .stage-desc,
.roadmap-item:first-child .milestone-row {
    left: 0;
}

/* 最后一个节点特殊处理 */
.roadmap-item:last-child {
    min-width: 200px;
}

.roadmap-item:last-child::after {
    width: 150%;
    background: linear-gradient(to right, 
        #055321 0%, 
        #055321 15%, 
        rgba(5, 83, 33, 0.2) 15%,
        rgba(5, 83, 33, 0.05) 100%
    );
}

/* 最后一个节点的说明文字 */
.roadmap-item:last-child .stage-desc {
    min-width: 220px;
    font-size: 11px;
}


/* 目标用户/用户规模文字 */
.description {
    font-size: 10px;
    line-height: 1.1;
    color: #055321;
}

/* 数字前缀（达/突破） */
.milestone-prefix {
    font-size: 12px;
    color: #055321;
}

/* 数字样式 */
.milestone {
    font-size: 16px;
    line-height: 1.1;
    color: #055321;
}

/* 生态伙伴区域 */
.partners-section {
    width: calc(100% - 240px);
    margin: 60px auto;
    margin-left: 120px;
    position: relative;
}

.partners-title {
    font-family: 'Noto Sans', sans-serif;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.4;
    margin-bottom: 40px;
    background: radial-gradient(50% 50% at 50% 50%, #A5D6A7 0%, #055321 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}
.partners-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    padding: 40px 0;
}

.partners-scroll {
    display: grid;
    grid-auto-flow: column dense;
    grid-template-rows: repeat(4, minmax(63px, auto));
    gap: 30px 60px;
    padding: 0 120px;
    transform: translateX(0);
    will-change: transform;
}

.partner-item {
    display: flex;
    align-items: center;
    justify-content: center;
    backface-visibility: hidden; /* 提高性能 */
}

/* 添加过渡效果 */
.partners-scroll.no-transition {
    transition: none !important;
}

/* 占位符样式 */
.partner-item.placeholder {
    visibility: hidden;
    pointer-events: none;
    height: 63px; /* 与普通logo高度一致 */
    width: 200px; /* 设置一个合适的宽度 */
}

/* 不同尺寸占位符 */
.partner-item.placeholder.large {
    height: 81px;
}

.partner-item.placeholder.xlarge {
    height: 99px;
}

.partner-item.placeholder.small {
    height: 45px;
}

.partner-item.placeholder.hamster {
    height: 108px;
}
/* 基础logo尺寸 */
.partner-item img {
    height: 63px;
    width: auto;
    object-fit: contain;
}

/* 大尺寸logo */
.partner-item.large img {
    height: 81px;
}

/* 特大尺寸logo */
.partner-item.xlarge img {
    height: 99px;
}

/* 小尺寸logo */
.partner-item.small img {
    height: 45px;
}

/* HAMSTER特殊处理 */
.partner-item.hamster img {
    height: 108px;
}

@keyframes scrollPartners {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(calc(-1 * (var(--column-width)))); /* 列宽 = 最小宽度 + 间距 */
    }
}

.partners-scroll:hover {
    animation-play-state: paused;
}
/* 左右遮罩 */
.partners-container::before,
.partners-container::after {
    content: '';
    position: absolute;
    top: 0;
    width: 20%;
    height: 100%;
    z-index: 2;
    pointer-events: none;
}

.partners-container::before {
    left: 0;
    background: linear-gradient(to right, 
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 30%,
        rgba(255, 255, 255, 0) 100%
    );
}

.partners-container::after {
    right: 0;
    background: linear-gradient(to left, 
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 30%,
        rgba(255, 255, 255, 0) 100%
    );
}

/* Logo 和标题样式 */
.intro-section {
    padding: 60px 80px;
    display: flex;
    margin: auto 4rem;
    flex-direction: column;
    align-items: flex-start;
}

/* Logo 和标题样式 */
.intro-content {
    width: 100%;
    max-width: 800px;
    margin-bottom: 60px;
    text-align: left;
    padding-left: 120px;
}

.intro-content h1 img {
    width: 140px;
    height: auto;
}

.intro-content h2 {
    font-family: 'Noto Sans', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #006838;
    line-height: 1.4;
    text-align: left;
}

.intro-content p {
    font-family: 'Noto Sans', sans-serif;
    font-size: 16px;
    line-height: 1.6;
    color: #2F2F2F99;
    max-width: 580px;
    text-align: left;
    margin: 0;
}

/* 3D模型容器样式 */
.intro-image {
    width: 500px;
    height: 500px;
    position: relative;
    align-self: center;
}

model-viewer {
    width: 100%;
    height: 100%;
    background-color: transparent;
}

/* 全局容器样式 */
.container {
    max-width: 1440px;
    margin: 0 auto;
    overflow-x: hidden;
}

/* 第一个节点特殊处理 */
.roadmap-item:first-child {
    margin-left: -30px; /* 整体向左偏移 */
}

.roadmap-item:first-child .milestone-content {
    margin-left: -30px; /* 文字内容额外向左偏移 */
}

.roadmap-item:first-child .time {
    left: -30px; /* 时间文字也相应左移 */
}

.roadmap-item:first-child::before {
    left: 0; /* 圆点保持原位 */
}

.roadmap-item:first-child::after {
    left: 12px; /* 线条起点保持不变 */
}



/* 公告区域样式 */
.announcement-section {
    width: 100%;
    margin: 0 auto;
    padding: 1rem 0;
    overflow: hidden; /* 确保滚动内容不溢出 */
}

.announcements-container {
    max-width: 1200px;
    background: #43A0464D;
    margin: 0 auto;
    border-radius: 4px;
    padding: 0.8rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* 滚动公告容器 */
.announcement-scroll {
    flex: 1;
    height: 24px; /* 设置固定高度 */
    overflow: hidden;
    position: relative;
}

/* 滚动公告列表 */
.announcement-list {
    position: absolute;
    width: 100%;
    animation: scrollAnnouncement 12s linear infinite;
    align-items: center;
    text-align: center;
}

/* 公告项样式 */
.announcement-item {
    height: 24px;
    line-height: 24px;
    cursor: pointer;
    color: #055321;
    transition: color 0.3s ease;
}

.announcement-item:hover {
    color: var(--primary-color);
}

/* 滚动动画 */
@keyframes scrollAnnouncement {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(-100%);
    }
}


/* 暂停滚动当hover时 */
.announcement-scroll:hover .announcement-list {
    animation-play-state: paused;
}

/* 统一左侧边距 */
.intro-content,
.announcement-container {
    padding-left: 80px;  /* 与头部logo左侧边距匹配 */
}

/* 弹出层样式 */
.announcement-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    overflow: auto;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 90%;
    width: 100%;
    max-height: 90vh;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
}

.modal-title {
    margin: 0;
}

.modal-close {
    background: none;
    border: none;
    cursor: pointer;
}

.modal-body {
    margin-top: 20px;
    overflow-y: auto;
    flex: 1;
}

.modal-content-wrapper img,
.modal-content-wrapper video,
.modal-content-wrapper iframe {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    object-fit: contain;
}
.no-announcements {
    text-align: center;
    padding: 40px;
    color: #666;
}
/* Constrain images within the modal */
.modal-content-wrapper img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto; /* Center the image if needed */
}

/* Constrain images within the intro section */
.intro-image img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto; /* Center the image if needed */
}

/* Constrain images within feature items */
.feature-image img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto; /* Center the image if needed */
}

@media (max-width: 1200px) {
    .roadmap-grid {
        padding-left: 80px;
        width: calc(100% - 80px);
    }
    .partners-section {
        width: calc(100% - 160px);
        margin-left: 80px;
    }
    
    .partners-scroll {
        padding: 0 80px;
        gap: 20px 40px;
    }
    .container {
        padding: 0 40px;
    }
    
    .launch-section {
        padding: 0 0px;
    }
    
    .intro-content h1 {
        font-size: 42px;
    }
    
    .intro-content h2 {
        font-size: 32px;
    }
    .intro-content {
        padding-left: 80px;
    }
    .announcement-section {
        width: calc(100% - 160px);
        margin-left: 80px;
    }

    .announcement-container {
        padding: 0.8rem 80px;
    }
    
}
@media (max-width: 768px) {

    .roadmap-section {
        display: none;
    }
    .roadmap-description p {
        font-size: 12px;
    }
    .roadmap-grid {
        flex-direction: column;
        gap: 40px;
    }

    .roadmap-item,
    .roadmap-item:last-child {
        width: 100%;
        min-width: 0;
    }

    .milestone-content {
        margin-left: 20px;
    }
    .roadmap-grid {
        padding-left: 40px;
        width: calc(100% - 40px);
    }
    .partners-section {
        width: calc(100% - 80px);
        margin-left: 40px;
        display: none;
    }
    
    .partners-scroll {
        padding: 0 40px;
        gap: 15px 30px;
    }
    
    .partners-title {
        font-size: 24px;
        margin-bottom: 30px;
    }
    
    /* 移动端logo尺寸 */
    .partner-item img {
        height: 54px;
    }
    
    .partner-item.large img {
        height: 72px;
    }
    
    .partner-item.xlarge img {
        height: 90px;
    }
    
    .partner-item.small img {
        height: 36px;
    }
    
    .partner-item.hamster img {
        height: 99px;
    }

    .main-title {
        font-size: 28px;
    }
    
    .features-section {
        padding: 40px 20px;
    }
    
    .feature-item {
        flex-direction: column !important;
        gap: 40px;
        margin-bottom: 60px;
    }
    
    .feature-content,
    .feature-image {
        width: 100%;
        flex: 0 0 100%;
    }
    
    .feature-content,
    .feature-item:nth-child(odd) .feature-content,
    .feature-item:nth-child(even) .feature-content {
        text-align: center;
    }
    
    .feature-image img {
        height: 300px;
        width: auto;
    }
    
    .roadmap-grid {
        grid-template-columns: repeat(2, 1fr);
    }
    .counter-wrapper {
        padding: 8px 16px;
    }
    
    .counter {
        font-size: 64px;
        line-height: 87px;
    }

    .container {
        padding: 0 20px;
    }
    
    .intro-section {
        padding: 0;
        margin: 0;
    }
    
    .intro-content {
        margin-bottom: 40px;
    }
    
    .intro-content h1 {
        font-size: 36px;
    }
    
    .intro-content h2 {
        font-size: 28px;
    }
    
    .intro-image {
        width: 100%;
        max-width: 400px;
    }

    .intro-content {
        padding-left: 40px;
    }
    .announcement-section {
        width: 100%;
        margin-left: 0px;
    }
    
    .announcement-container {
        padding: 0.8rem 40px;
    }
    .modal-content {
        width: 95%;
        max-height: 90vh;
    }
    
    .modal-header {
        padding: 16px 20px;
    }
    
    .modal-body {
        padding: 20px;
    }
    
    .modal-title {
        font-size: 18px;
    }
    .launch-title {
        font-size: 32px;
        line-height: 44px;
        letter-spacing: 0.3em;
    }
    
    .counter {
        font-size: 24px;
        line-height: 32px;
    }
    
    .system-time {
        font-size: 16px;
        line-height: 24px;
        padding:  0;
        min-width: 180px;
    }
}
@media (max-width: 480px) {
    .roadmap-grid {
        grid-template-columns: 1fr;
    }
}
/* Additional styles for other sections if needed */
</style>